
import { ApiService } from '..';

export const KnowledgeTestService = {
    get(slug) {
        return ApiService.get('knowledge-test', slug);
    }
};